import angular from 'angular';
import header from './header';
import ggCSV from './ggCSV';
import ggTable from './ggTable';
import ggPaginatedTable from './ggPaginatedTable';
import observables from './observables';
import notify from './notify';
import progressBarSetter from './progressBarSetter';
import FeatureFlagsHelper from './featureFlagsHelper';
import CorsProxy from './corsProxy';
import UserExploreConstants from './userExploreConstants';
import CampaignTargetingsConstants from './campaignTargetingsConstants';
import HideThatProduct from './hideThatProduct';

export default angular.module('app.services', [
  header.name,
  ggCSV.name,
  ggTable.name,
  ggPaginatedTable.name,
  observables.name,
  notify.name,
  progressBarSetter.name,
  FeatureFlagsHelper.name,
  CorsProxy.name,
  UserExploreConstants.name,
  CampaignTargetingsConstants.name,
  HideThatProduct.name
]);



/** WEBPACK FOOTER **
 ** ./src/services/services.js
 **/